import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment as env} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService { 

  constructor(private http:HttpClient) { }



  siteuserLogin(frmAr:any = []){
    return this.http.post(env.apiurl+'login', {
      email:frmAr.useremail,
      password: frmAr.userpass
    }).pipe(rawData => {return rawData;});
  }

  checkuserExists(phone:string){
    return this.http.post(env.apiurl+'get-user-by-phone', {
      phone:phone,
    }).pipe(rawData => {return rawData;});
  }


  // checkuserExistsbyPhone(email:string){
  //   return this.http.post(env.apiurl+'get-user-by-email', {
  //     email:email,
  //   }).pipe(rawData => {return rawData;});
  // }

  orderPlace(oi:any){
    return this.http.post(env.apiurl+'place-order', oi)
    .pipe(rawwData=>{return rawwData});
  }
}
